var render = function render(_c,_vm){return _c('div',{staticClass:"color-dot",class:[_vm.data.class, _vm.data.staticClass, _vm.props.size],style:({ 'background-color': _vm.props.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }